'use client'

import { submitEmailToList, type callBackObject } from '@/lib/mailchimp'
import { toast } from '@/components/ui/use-toast'
import { useEffect } from 'react'

const CONTAINER_SELECTOR =
  '.subscribe-bottom-container, .inputContainer'
const INIT_ATTR = 'data-artho-newsletter-bound'


function bindNewsletterSubscribe(container: Element): (() => void) | void {
  if (container.hasAttribute(INIT_ATTR)) return

  const input =
    (container.querySelector('.mailchimp-email') as HTMLInputElement | null) ??
    (container.querySelector('input[type="email"]') as HTMLInputElement | null)

  const submitButton =
    (container.querySelector('.mailchimp-subscribe') as HTMLInputElement | null) ??
    (container.querySelector('input[type="submit"]') as HTMLInputElement | null)

  if (!input) return

  container.setAttribute(INIT_ATTR, 'true')
  const emailInput = input

  async function handleSubmit() {
    const email = emailInput.value.trim()
    if (!email.includes('@')) return
    await submitEmailToList(email)
      .then((result) => {
        emailInput.value = ''
        toast(result.toast)
      })
      .catch((err) => console.log('err', err))
  }


  const onSubmit = (e: Event) => {
    e.preventDefault()
    void handleSubmit()
  }

  const form = container.closest('form') ?? container.querySelector('form')
  if (form) {
    form.addEventListener('submit', onSubmit)
    return () => {
      form.removeEventListener('submit', onSubmit)
      container.removeAttribute(INIT_ATTR)
    }
  }

  if (submitButton) {
    submitButton.addEventListener('click', onSubmit)
    return () => {
      submitButton.removeEventListener('click', onSubmit)
      container.removeAttribute(INIT_ATTR)
    }
  }
}

export function ArthoNewsletterSubscribe() {
  useEffect(() => {
    const cleanups: Array<(() => void) | void> = []
    document.querySelectorAll(CONTAINER_SELECTOR).forEach((container) => {
      cleanups.push(
        bindNewsletterSubscribe(container),
      )
    })
    return () => {
      cleanups.forEach((cleanup) => cleanup?.())
    }
  }, [])

  return null
}